import apiClient from './apiClient';

/**
 * Analysis dashboards (/analysis) — one call per dashboard so a slow panel
 * never blocks the others. Every endpoint takes the same IST date window.
 */
const range = (from, to) => `?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`;

const analysisService = {
    /** Rental + operating utilization per machine, with a monthly trend. */
    getUtilization: (from, to) => apiClient.get(`/analytics/utilization${range(from, to)}`),

    /** Days on rent where the machine never ran, per machine and per day. */
    getIdleTime: (from, to) => apiClient.get(`/analytics/idle-time${range(from, to)}`),

    /** Days between a de-hire and the next rental, plus what is waiting now. */
    getOffRentLatency: (from, to) => apiClient.get(`/analytics/off-rent-latency${range(from, to)}`),

    /** PM plan adherence + how PM tickets were closed against their due date. */
    getMaintenanceCompliance: (from, to) => apiClient.get(`/analytics/maintenance-compliance${range(from, to)}`),

    /** Rental pipeline: quoted / won / lost and the conversion rate. */
    getQuoteConversion: (from, to) => apiClient.get(`/analytics/quote-conversion${range(from, to)}`),

    /** Accrued and billed revenue per machine. */
    getRevenuePerAsset: (from, to) => apiClient.get(`/analytics/revenue-per-asset${range(from, to)}`),

    /** Revenue per customer against the service burden they generate. */
    getCustomerProfitability: (from, to) => apiClient.get(`/analytics/customer-profitability${range(from, to)}`),

    /**
     * Market & demand: 24 months of demand history, a forecast for the coming
     * months, dynamic-pricing suggestions per category, and the MEWP market
     * headlines the Fleet Agent collects (stored, never mailed).
     * Ignores the date window — the forecast needs its own fixed history.
     */
    getMarketDemand: () => apiClient.get('/analytics/market-demand'),

    /**
     * Finance roll-up over the telematics-installed fleet: accrued vs billed
     * revenue, the Fleet Agent's staged extra hours (O1) and leakage (R7),
     * idle and telemetry-untrusted machines, and the action queue — every
     * rupee that needs a finance decision. Nothing here posts to the ledger.
     */
    getFinanceOverview: (from, to) => apiClient.get(`/analytics/finance-overview${range(from, to)}`),
};

export default analysisService;
